import { ReactElement } from 'react';

import { Box, SxProps, Theme } from '@mui/material';

import { appColors } from '../assets/appColors';

type BackrsCardProps = Readonly<{
  children: ReactElement | ReactElement[];
  sx?: SxProps<Theme>;
  onClick?: () => void;
}>;

/** This component will just render children with some shared padding and border radius.  */
export const BackrsCard = ({ children, sx, onClick }: BackrsCardProps) => {
  return (
    <Box
      onClick={onClick}
      sx={
        {
          ...cardStyle,
          ...sx,
          cursor: onClick ? 'pointer' : 'default',
          boxSizing: 'border-box',
        } as SxProps<Theme>
      }
    >
      {children}
    </Box>
  );
};

const cardStyle: SxProps<Theme> = {
  borderRadius: 2,
  p: 3,
  backgroundColor: appColors.neutral.white,
};
